import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import * as Sentry from '@sentry/vue'

import App from './App.vue'
import router from './router'
import { initializeAxios } from './utils/axios'
import InactivityWarningModal from '@/components/modals/InactivityWarningModal.vue'

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'

// Import MDI font
import '@mdi/font/css/materialdesignicons.css'

// Import vue-the-mask
import VueTheMask from 'vue-the-mask'

// Import ptBrTableLocale
import { ptBrTableLocale } from './utils/configuracoesTabela'

// Initialize the Pinia store
const pinia = createPinia()

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#1976D2',
          secondary: '#424242',
          accent: '#82B1FF',
          error: '#FF5252',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FFC107',
        },
      },
    },
  },
  locale: {
    locale: 'pt',
    messages: { pt: ptBrTableLocale },
  },
})

// Create the Vue app
const app = createApp(App)

Sentry.init({
  app,
  dsn: import.meta.env.SENTRY_DSN,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  release: `tmkt-vuejs@${import.meta.env.VITE_APP_VERSION || '0.0.0'}`,
  environment: import.meta.env.MODE, // 'development' ou 'production'
  autoSessionTracking: true, // Enable crash-free sessions tracking
  // This enables automatic instrumentation (highly recommended),
  // but is not necessary for purely manual usage
  // If you only want to use custom instrumentation:
  // * Remove the `BrowserTracing` integration
  // * add `Sentry.addTracingExtensions()` above your Sentry.init() call
  integrations: [Sentry.browserTracingIntegration()],
  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: import.meta.env.SENTRY_TRACE_SAMPLE_RATE,
  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  tracePropagationTargets: [
    'localhost',
    '/^https://yourserver.io/api/',
    'https://pdg-tmkt.precodogas.com.br/login',
  ],
})

// Use Pinia store and router
app.use(pinia)
app.use(router)
app.use(vuetify)
app.use(VueTheMask)

// Registrar o componente modal globalmente
app.component('InactivityWarningModal', InactivityWarningModal)

// Initialize axios with the router reference to handle 401 redirects
initializeAxios(router)

// Mount the app
app.mount('#app')
